import React from 'react';
import logo from '../images/ACL-logo.png';
import $ from 'jquery';
import Headerimg from "../images/header_bg3.jpg";
import HHStopbarlogo from "../images/HHS-topbar-logo.png"
import ACLtopbarlogo from "../images/ACL-topbar-logo.png"

class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            topicBox: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            window.open("/Resources?search3=" + this.state.topicBox + "#result");
        }
    }

    componentDidMount() {
        $('li').on('click', function () {
            $('li').removeClass('active');
            $(this).toggleClass('active');
        });
    }

    render() {
        return (
            <div className="fixedheader">
                <div class="grid grid-cols-1 sm:grid-cols-12 w-full mx-auto gap-4 bg-white">
          <div class="col-span-1 sm:col-span-4 my-auto md:col-span-2 lg:col-span-2 xl:col-span-1 px-8 md:px-0 mx-auto items-center w-3/4 sm:w-full">
            <div class="grid grid-cols-2 w-1/2 sm:w-full m-auto sm:mx-auto gap-0 md:h-14 py-2 pl-2">
              <div class="col-1 sm:pl-0 mx-auto my-auto">
                <a href="https://hhs.gov"><img src={HHStopbarlogo} alt="HHS logo" width="30" height="30" class="hhslogo my-auto align-middle inline" /></a>
              </div>
              <div class="col-1 mx-auto my-auto">
                <a href="https://acl.gov"><img src={ACLtopbarlogo} alt="ACl Logo" width="60" height="30" class="acllogo my-auto align-middle inline" /></a>
              </div>
            </div>
          </div>
          <div class="col-span-1 sm:col-span-8 md:col-span-9 lg:col-span-9 xl:col-span-10 px-8 md:px-0 mx-auto items-center my-auto w-full">
            <div class="rich-text-banner items-center text-sm inline-block align-middle py-0 sm:py-1 my-auto">
              <p class="inline-block align-middle text-sm">
                HHS Administration for Community Living
              </p>
              {/* <button data-toggle-target=".search-modal" data-toggle-body-class="showing-search-modal" data-set-focus=".search-modal .search-field" aria-expanded="false" aria-label="Show search modal" class="px-1 py-1 flex-shrink-0 inline btnclose">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="h-6 w-auto" color="#fff"  xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                  </path>
                </svg>
              </button> */}
            </div>
          </div>
        </div>
                {/* Navigation bar with dark blue background */}
                <div className="flex items-center justify-between w-full px-4 pt-4" style={{ backgroundColor: "#003366" }}>
                    <div className="text-white text-md font-medium">
                        <ul className="flex space-x-6 mb-2">
                            <li><a href="/" className="hover:text-gray-200">Home</a></li>
                            <li><a href="/add-resource" className="hover:text-gray-200">Add Resource</a></li>
                            <li><a href="/view-resources" className="hover:text-gray-200">View Resources</a></li>
                            <li><a href="/" className="hover:text-gray-200">Instructions</a></li>
                        </ul>
                    </div>
                </div>

                {/* Header image and title */}
                <div className="w-full relative">
                    <img className="w-full h-96 object-cover" src={Headerimg} alt="Header Image" style={{ opacity: 0.5 }} />
                    
                    {/* Centered text box with transparent white background */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full sm:w-1/3 p-4 text-center text-black bg-white bg-opacity-70">
                        <p className="text-4xl md:text-4xl lg:text-6xl font-bold font-bold text-blue-900 leading-normal"><span className="leading-normal"> APS ToolKIT <br />Admin Portal</span>
                       
                        </p>
                    </div>
                </div>

                
            </div>
        );
    }
}

export default Header;